<script lang="ts">
    import ProductGrid from "./ProductGrid.svelte";
    import {createEventDispatcher} from "svelte";
    import {Cart} from "../../models/cart";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import NauiCheckbox from "../../naui/atoms/NauiCheckbox.svelte";
    import CircularProgress from "@smui/circular-progress";
    import {IPartResponse, IPriceResponse, IServiceResponse} from "../../interfaces";
    import {getCodModeloTasa, getCodToAccessory, getSelectedCity} from "../../utils";
    import {ManagerVehicles} from "../../models/manager-vehicles";

    export let loading: boolean = true;
    export let title: string;
    export let data: Array<any> = [];
    export let page = 1;
    export let cart: Cart;
    export let showViewMore: boolean = true;
    export let dialog: any = {
        open: false,
        message: '',
        checkbox: false
    }
    let incluyeInstalacion: boolean = false;
    let service: IServiceResponse;
    let part: IPartResponse;
    let service_price_payload: any;
    let part_price_payload: any;
    let loadingPrice: boolean = false;
    let detail;
    let price: IPriceResponse;


    const formatter = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
    });
    const dispatch = createEventDispatcher();

    function checkInstallation() {
        return new Promise((resolve, reject) => {
            loading = true;
            const url = new URL('/backend/servicio/search-repuestos-in-servicios/', location.origin);
            url.search = new URLSearchParams({
                cod_referencia: detail.item.reference
            }).toString();
            fetch(url.toString(), {
                method: 'GET'
            })
                .then(response => response.json())
                .then(response => {
                    loading = false;
                    if (Object.keys(response).length > 0) {
                        service_price_payload = {
                            "ciudad": detail.price_payload.ciudad,
                            "codReferencia": response.servicios[0].cod_referencia,
                            "incluyeInstalacion": 1,
                            "modeloTasa": detail.price_payload.modeloTasa,
                            "tipo": response.servicios[0].tipo_dinissan,
                        }
                        service = response.servicios[0];
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                })
                .catch(error => {
                    console.error(error);
                    reject(error);
                });
        });
    }

    async function addToCart(event) {
        if (cart) {
            detail = event.detail;
            try {
                switch (detail.item.type) {
                    case 'R':
                        part = detail.item;
                        part_price_payload = detail.price_payload;
                        checkInstallation().then((tieneInstalacion) => {
                            if (tieneInstalacion) {
                                price = detail.price_obj;
                                dialog = {
                                    open: true,
                                    message: 'El repuesto ha sido agregado al carrito',
                                    checkbox: true
                                }
                            } else {
                                cart.addPart(detail);
                                cart.update();
                                dialog = {
                                    open: true,
                                    message: 'El repuesto ha sido agregado al carrito'
                                }
                            }
                        });
                        break;
                    case 'P':
                        incluyeInstalacion = detail.item.installationEnabled;
                        price = detail.price_obj;
                        dialog = {
                            open: true,
                            message: 'El accesorio ha sido agregado al carrito',
                            checkbox: true
                        }
                        break;
                    case 'Z':
                        cart.addService(detail);
                        await cart.update();
                        dialog = {
                            open: true,
                            message: 'El servicio ha sido agregado al carrito'
                        }
                        break;
                    case 'S':
                        cart.addAccessory(detail);
                        await cart.update();
                        updateTotal();
                        dialog = {
                            open: true,
                            message: 'El servicio ha sido agregado al carrito'
                        }
                        break;

                }
            } catch (e) {
                dialog = {
                    open: true,
                    message: 'Se ha presentado un error.'
                }
            }
        }
    }

    function closeDialog() {
        dialog.open = false;
        dialog.message = '';
    }

    function queryPrice() {
        return new Promise((resolve, reject) => {
            if (detail.price_payload) {
                loadingPrice = true;
                const url = new URL('/backend/servicio/precio-disponibilidad/', location.origin);
                url.search = new URLSearchParams(detail.price_payload).toString();
                fetch(url.toString(), {method: 'GET'})
                    .then(r => r.json())
                    .then((response) => {
                        loadingPrice = false;
                        const price = response.prices[0];
                        detail.price = price.precioNeto;
                        resolve(price);
                    })
                    .catch((error) => {
                        detail.price = null;
                        loadingPrice = false;
                        reject(error);
                    });
            } else {
                resolve(null);
            }
        });
    }

    function queryPricePart() {
        return new Promise((resolve, reject) => {
            if (detail.price_payload) {
                loadingPrice = true;
                const url = new URL('/backend/servicio/precio-disponibilidad/', location.origin);
                if (incluyeInstalacion) {
                    url.search = new URLSearchParams(service_price_payload).toString();
                } else {
                    url.search = new URLSearchParams(part_price_payload).toString();
                }
                fetch(url.toString(), {
                    method: 'GET'
                })
                    .then(response => response.json())
                    .then(response => {
                        loadingPrice = false;
                        const price = response.prices[0];
                        detail.price = price.precioNeto;
                        resolve(price);
                    })
                    .catch(error => {
                        detail.price = null;
                        loadingPrice = false;
                        reject(error);
                    });
            } else {
                resolve(null);
            }
        });
    }

    async function updatePrice() {
        const manager = ManagerVehicles.getInstance();
        const selectedVehicle = manager.selected;
        const selectedCity = getSelectedCity();
        let path = [];
        switch (detail.item.type) {
            case 'P':
                const {link_imagen, imagen_thumbnail} = detail.meta.imagenes.length > 0 ? detail.meta.imagenes[0] : {}
                path = ['', 'accesorio'];
                if (detail.meta.brand?.slug) {
                    path.push(detail.meta.brand.slug);
                    if (detail.meta.linea?.slug) {
                        path.push(detail.meta.linea.slug);
                        path.push(detail.meta.slug)
                    }
                }
                if (incluyeInstalacion) {
                    detail.price_payload.incluyeInstalacion = 1;
                    queryPrice().then(price => {
                            detail = {
                                item: {
                                    id: detail.meta.id,
                                    type: 'P',
                                    image: link_imagen ?? imagen_thumbnail,
                                    name: detail.meta.nombre,
                                    description: detail.meta.descripcion,
                                    delivery: false,
                                    reference: price.codReferencia,
                                    codModelo: getCodToAccessory(detail.meta?.linea),
                                    installationEnabled: detail.meta.instalacion_habilitada,
                                    route: path.join('/')
                                },
                                city: {
                                    id: selectedCity
                                },
                                installation: true,
                                isNew: false,
                                vin: selectedVehicle?.vin ?? '',
                                placa: selectedVehicle?.placa ?? '',
                                prevPrice: price.precio_total,
                                price: price.precioNeto,
                                flag: price.porcDescuento && price.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
                                quantity: 1,
                                byOrder: false,
                                tipo: 'P',
                                price_payload: detail.price_payload,
                                meta: detail.meta,
                                price_obj: price
                            }
                        }
                    )
                } else {
                    detail.price_payload.incluyeInstalacion = 0;
                    queryPrice().then(price => {
                            detail = {
                                price: price.precioNeto,
                                prevPrice: price.precio_total,
                                flag: price.porcDescuento && price.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
                                tiempoDespacho: price.tiempoDespacho,
                                quantity: 1,
                                disponibilidad: price.disponibilidad ? 1 : 0,
                                item: {
                                    id: detail.meta.id,
                                    type: 'P',
                                    image: detail.item.image ?? '',
                                    name: detail.meta.nombre,
                                    reference: price.codReferencia,
                                    delivery: true,
                                    codModelo: getCodToAccessory(detail.meta?.linea),
                                    route: path.join('/')
                                },
                                city: {
                                    id: selectedCity
                                },
                                tipo: 'R',
                                price_payload: detail.price_payload,
                                meta: detail.meta,
                                price_obj: price
                            }
                        }
                    )
                }
                break;
            case 'R':
                queryPricePart().then(price => {
                    if (incluyeInstalacion) {
                        detail = {
                            item: {
                                id: service.pk,
                                name: service.nombre,
                                reference: service.cod_referencia,
                                type: 'R',
                                codModeloTasa: service_price_payload.modeloTasa,
                                image: service.images?.length > 0 ? service.images[0].image : '',
                                vin: selectedVehicle?.vin ?? '',
                                route: ['', 'servicio', service.slug].join('/')
                            },
                            city: {
                                id: selectedCity
                            },
                            prevPrice: price.precio_total,
                            price: price.precioNeto,
                            flag: price?.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
                            quantity: 1,
                            tipo: 'S',
                            price_payload: detail.price_payload,
                            meta: detail.meta,
                            price_obj: price
                        }
                    } else {
                        detail = {
                            price: price.precioNeto,
                            prevPrice: price.precio_total,
                            flag: price?.porcDescuento > 0 ? `DCTO ${price.porcDescuento}% ` : '',
                            tiempoDespacho: price.tiempoDespacho,
                            quantity: 1,
                            disponibilidad: price.disponibilidad ? 1 : 0,
                            item: {
                                id: part.pk,
                                type: 'R',
                                image: part.image ?? '',
                                name: part.name,
                                reference: part.reference,
                                delivery: true,
                                codModelo: service_price_payload.modeloTasa,
                                route: path.join('/')
                            },
                            city: {
                                id: selectedCity
                            },
                            tipo: 'R',
                            price_payload: detail.price_payload,
                            meta: detail.meta,
                            price_obj: price
                        }
                    }
                })
                break;
        }
    }

    async function addItem() {
        switch (detail.item.type) {
            case 'P':
                if (detail.tipo === 'P') {
                    cart.addAccessory(detail);
                } else if (detail.tipo === 'R') {
                    cart.addPart(detail);
                }
                break;
            case 'R':
                if (detail.tipo === 'S') {
                    cart.addService(detail);
                } else if (detail.tipo === 'R') {
                    cart.addPart(detail);
                }
                break;
        }

        await cart.update();
        incluyeInstalacion = false;
        closeDialog();
    }

    function updateTotal() {
        dispatch('updateTotal');
    }

    function next() {
        page++;
        dispatch('next', {
            page
        });
    }

    export function clear() {
        data = [];
        loading = true;
        page = 1;
    }
</script>

{#if title}
    <h2 class="mb-15">{title}</h2>
{/if}

<ProductGrid {data}
             {loading}
             on:add={addToCart}/>
{#if showViewMore}
    <div class="box-r mt-1">
        <div class="view-more pointer"
             on:click={()=> next()}>
            Ver más
        </div>
    </div>
{/if}

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {#if dialog.checkbox}
            <div class="productPreview mb-1">
                <div>
                    <NauiCheckbox label="Lleva tu accesorio instalado por expertos"
                                  bind:value={incluyeInstalacion}
                                  on:change={updatePrice}
                    />
                </div>
                <div class="box relative">
                    {#if detail.item.image}
                        <img class="w-100" src="{detail.item.image}" alt="{detail.item.name}">
                    {:else}
                        <img class="w-100" src="/static/storefront/pix/no_foto.jpg" alt="{detail.item.name}">
                    {/if}
                    {#if detail.flag }
                        <div class="discount absolute">
                            {detail.flag}
                        </div>
                    {/if}
                </div>
                {#if detail.item?.brand}
                    <div class="brand">{detail.item.brand}</div>
                {/if}
                <div class="name">{detail.item.name}</div>
                <div class="grid-1-auto">
                    <div>
                        {#if detail.price}
                            {#if loadingPrice}
                                <CircularProgress style="height: 18px; width: 18px;" indeterminate/>
                            {:else if detail.price >= 0 && typeof detail.price == 'number'}
                                <div class="price">{formatter.format(detail.price)}</div>
                            {:else}
                                <div class="price">NO DISPONIBLE</div>
                            {/if}
                        {/if}
                    </div>
                    <div>

                    </div>
                </div>
            </div>

        {:else}
            {dialog.message}
        {/if}
    </Content>
    <Actions>
        <div class="box sx-ii">
            {#if dialog.checkbox}
                <NauiButton caption="AGREGAR"
                            color="accent"
                            mode="solid"
                            on:click={()=>addItem()}/>
            {:else}
                <NauiButton caption="ACEPTAR"
                            color="accent"
                            mode="solid"
                            on:click={()=>closeDialog()}/>
            {/if}
        </div>
    </Actions>
</Dialog>

<style>
    .brand {
        font-size: 12px;
        text-transform: uppercase;
        margin: .25rem 0;
    }

    .name {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: .25rem;
    }

    .price {
        font-size: 18px;
    }

    .discount {
        font-size: 12px;
        background: black;
        padding: .25rem;
        bottom: 0;
        left: 0;
        color: white;
        font-weight: 600;
    }
</style>